import script from "./fw11_futured_medias.vue?vue&type=script&setup=true&lang=js"
export * from "./fw11_futured_medias.vue?vue&type=script&setup=true&lang=js"

import "./fw11_futured_medias.vue?vue&type=style&index=0&id=dd0a31d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd0a31d0"]])

export default __exports__